import { useState } from 'react';
import { useHistory } from 'react-router-dom';

const pages = ['overview', 'cropping', 'data-management', 'agent-settings'];
const pathNameToTab = pages.reduce(
  (acc, page, index) => ({ ...acc, [page]: index }),
  {}
);
const tabStyle = { textTransform: 'none' };
const labels = ['Overview', 'Cropping', 'Data Management', 'Agent Settings'];

export default ({ params }) => {
  const history = useHistory();
  const [selectedTab, setSelectedTab] = useState(
    pathNameToTab[params.page] ?? 0
  );

  const handleChange = (_, pageIndex) => {
    history.push(`/${pages[pageIndex]}`);
    setSelectedTab(pageIndex);
  };

  return {
    selectedTab,
    handleChange,
    labels,
    tabStyle,
  };
};
